import i18n from '@/store/i18n';

import { IntradorRouteConfig } from '@/router/router';
import { MenuPosition } from '@/layouts/back-office/aside/MenuPosition';

const Render = {
  render(c: any) {
    return c('router-view');
  },
};

const routes: IntradorRouteConfig[] = [
  {
    name: 'Jobs',
    path: 'jobs',
    icon: 'tasks',
    title: () => 'Jobs',
    component: () => {
      return import(/* webpackChunkName: "job_dashboard" */'../pages/JobDashboard.vue')
        .then((m) => m.default);
    },
    menuPosition: MenuPosition.TOP,
    homeWeight: 1,
  },
  {
    name: 'Pipelines',
    path: 'pipelines',
    icon: 'project-diagram',
    title: () => 'Pipelines',
    component: () => {
      return import(/* webpackChunkName: "pipeline_dashboard" */'../pages/PipelineDashboard.vue')
        .then((m) => m.default);
    },
    menuPosition: MenuPosition.TOP,
    homeWeight: 1,
  },
  {
    name: 'Checks Review',
    path: 'checks_review',
    icon: 'check-double',
    title: () => 'Checks Review',
    component: () => {
      return import(/* webpackChunkName: "checks_review" */'../pages/ChecksReview.vue')
        .then((m) => m.default);
    },
    menuPosition: MenuPosition.TOP,
    homeWeight: 1,
  },
  {
    name: 'job',
    path: 'job/:jobID',
    title: () => 'Job',
    props: (route) => ({
      ...route.params,
    }),
    component: () => {
      return import(/* webpackChunkName: "job_information" */'../pages/JobInformation.vue')
        .then((m) => m.default);
    },
  },
  {
    name: 'pipeline',
    path: 'pipeline/:pipelineID',
    title: () => 'Pipeline',
    props: (route) => ({
      ...route.params,
    }),
    component: () => {
      return import(/* webpackChunkName: "pipeline_information" */'../pages/PipelineInformation.vue')
        .then((m) => m.default);
    },
  },
];

export default routes;
